import { routerMiddleware } from "connected-react-router";
import { applyMiddleware, compose, createStore as _createStore } from "redux";
import thunk from "redux-thunk";
import history from "./history";
import rootReducer from "./modules/reducers";

function createStore() {
  const thunkArgument = {
    pubnub: {
      api: null
    }
  };
  // const enhancer = compose(applyMiddleware(...middleware, DevTools.instrument()));
  // eslint-disable-next-line no-underscore-dangle
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const initialState = {};

  return _createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(thunk.withExtraArgument(thunkArgument)),
      applyMiddleware(routerMiddleware(history))
    )
  );
}

const store = createStore();

export default store;
